import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { generateCode } from '../api';

function ProjectAI({ projectName }) {
  const { token } = useAuth();
  const [prompt, setPrompt] = useState('');
  const [result, setResult] = useState('');

  const handleGenerate = async () => {
    const res = await generateCode(token, projectName, prompt);
    setResult(res.result);
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Project AI: {projectName}</h1>
      <textarea value={prompt} onChange={e => setPrompt(e.target.value)} placeholder="Describe your project" />
      <button onClick={handleGenerate}>Generate</button>
      <pre>{result}</pre>
    </div>
  );
}

export default ProjectAI;
